<template>
  <div :class="this.cardClass">
    <div class="ui center aligned basic segment">
      <img
        v-if="this.image"
        :src="image"
        height="90px"
        width="99px"
      >
      <i
        v-else
        class="huge icons"
      >
        <i
          v-for="(icon, index) in data.icons"
          :key="icon"
          :class="iconFor(icon, index)"
        />
      </i>
    </div>
    <h2 :class="this.iconHeaderClass">
      <div class="content">
        {{ this.data.label }}
      </div>
    </h2>
  </div>
</template>

<script>
export default {
  name: 'AlertSettingsOptionCard',
  props: ['selected', 'data'],
  computed: {
    cardClass: function () {
      if (this.selected) {
        return 'ui inverted pink segment'
      }

      return 'ui pink segment'
    },
    iconHeaderClass: function () {
      if (this.selected) {
        return 'ui inverted center aligned icon header'
      }
      return 'ui center aligned icon header'
    },
    image: function () {
      const imageName = this.data.image
      if (imageName) {
        return '/static/alert-settings/' + this.data.image + '.png'
      }
      return undefined
    },
  },
  methods: {
    iconFor: function (icon, index) {
      let suffix = 'icon'

      if (this.selected) {
        suffix = 'inverted '.concat(suffix)
      }

      if (index > 0) {
        suffix = 'bottom right corner '.concat(suffix)
      }

      const output = icon + ' ' + suffix

      return output
    },
  },
}
</script>

<style scoped>

</style>
